import { Result, Button } from 'antd';
import React from 'react';
export const OfflineComponent = ({ message }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Result
      status="500"
      title="Oops! Something went wrong."
      subTitle={
        message ||
        'Try reloading the page. If error still persists, please contact support team or try again later.'
      }
      extra={[
        <Button key="reload" type="primary" onClick={handleRefresh}>
          Reload Page
        </Button>,
      ]}
    />
  );
};
